import React from "react";
import { Box, CircularProgress, Divider } from "@mui/material";
import { capitalizeString, formatFriendlyDate } from "utils";
import { baseStyle, spanDescriptionStyle, spanTitleStyle, statusIdParsed, statusStyles } from "./const";

export const JobDetail = ({ jobData, children }: { jobData: any, children: React.ReactNode }) => {
  const { name, createDate, status, type, errors } = jobData;

  return (
    <Box>
      <Box sx={{
        width: "650px",
        display: "flex",
        justifyContent: "space-between",
        padding: "16px 24px",
      }}>
        <h2 style={{
          margin: 0,
          fontSize: "20px",
          fontWeight: 700,
          color: "#054254",
          lineHeight: "1",
        }}>Job Detail</h2>
        {children}
      </Box>
      <Divider />
      <Box sx={{
        width: "650px",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        padding: "16px 24px 24px",
      }}>
        <Box sx={{
          display: "flex",
          flexDirection: "column",
        }}>
          <span style={spanTitleStyle}>Job Name</span>
          <span style={spanDescriptionStyle}>{name}</span>
        </Box>
        <Box sx={{
          display: "flex",
          flexDirection: "column",
        }}>
          <span style={spanTitleStyle}>Date</span>
          <span style={spanDescriptionStyle}>{formatFriendlyDate(createDate, true)}</span>
        </Box>
        <Box sx={{
          display: "flex",
          flexDirection: "column",
        }}>
          <span style={spanTitleStyle}>Status</span>
          <Box sx={{ ...baseStyle, ...(statusStyles[statusIdParsed(status)] || {}) }}>
            {capitalizeString(status)} {statusIdParsed(status) === 'IN_PROGRESS' && <CircularProgress size={10} />}
          </Box>
        </Box>
        <Box sx={{
          display: "flex",
          flexDirection: "column",
        }}>
          <span style={spanTitleStyle}>Message</span>
          <span style={spanDescriptionStyle}>{type}</span>
        </Box>
        <Box sx={{
          display: "flex",
          flexDirection: "column",
        }}>
          <span style={spanTitleStyle}>Log</span>
          <Box sx={{
            minHeight: "200px",
            padding: "16px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            backgroundColor: "#404040",
            color: "#D3D3D3",
            fontWeight: 500,
            fontSize: "14px",
            "& > span": {
              fontFamily: "Courier New, Courier, monospace !important",
            }
          }}>
            {
              errors?.length > 0
                ? errors.map((error: any) => (
                  <span>
                    {error}
                  </span>
                ))
                : <span>
                  No logs
                </span>
            }
          </Box>
        </Box>
      </Box>
    </Box>
  );
}